import type {
    MobileAlgoContext,
    Stage,
    StructureStageData,
    ConversionDal,
    ConversionAlgoConfig,
    StageHandler,
    StageRuntimeStore
} from '../types'
import {pointerUtils, type SnapshotDal} from '@wix/document-manager-core'
import {createStructureIterators} from '../conversionDal/utils/structureIterators'
import {ConversionDalNamespaces} from '../conversionDal/constants'

export const createStructureStage = (): Stage<StructureStageData> => {
    const handlers: StageHandler<StructureStageData>[] = []

    return {
        register: (handler: StageHandler<StructureStageData>) => {
            handlers.push(handler)
        },
        run: async (
            ctx: MobileAlgoContext,
            conversionDal: ConversionDal,
            initialSnapshot: SnapshotDal,
            pageId: string,
            config: ConversionAlgoConfig,
            stageRuntimeStore: StageRuntimeStore
        ) => {
            const structureIterators = createStructureIterators(
                conversionDal,
                pointerUtils.getPointer(config.rootPointer.id, ConversionDalNamespaces.structure)
            )

            await Promise.all(
                handlers.map(handler =>
                    handler({
                        globalContext: ctx,
                        conversionDal,
                        initialSnapshot,
                        structureIterators,
                        pageId,
                        config,
                        stageRuntimeStore
                    })
                )
            )
        }
    }
}
